import { If } from "components";
import { t } from "i18next";
import { ContentLayout, BoxShadowLayout } from "layouts";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import { DriverDetailsForm } from "../../components";
import { EMPTY_DRIVER_FORM_VALUES } from "../../constants";
import { getEditableDriverFormValues } from "../../helpers";
import { DriverDetailsProps } from "./DriverDetails.types";

import styles from "./DriverDetails.module.scss";

const DriverDetails = ({
  editableDriver,
  isEditableDriverLoading
}: DriverDetailsProps) => {
  const { editableDriverId } = useParams();

  return (
    <ContentLayout
      title={`${editableDriverId ? t("Edit") : t("New")} ${t("Driver")}`}
    >
      <BoxShadowLayout>
        <If condition={!!isEditableDriverLoading}>
          <div className={styles.driverDetails_loader}>
            <ClipLoader size={30} color="#fb3973" />
          </div>
        </If>

        <If condition={!editableDriverId || editableDriver}>
          <DriverDetailsForm
            defaultValues={
              editableDriver
                ? getEditableDriverFormValues(editableDriver)
                : EMPTY_DRIVER_FORM_VALUES
            }
          />
        </If>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default DriverDetails;
